import { Box, Flex, HStack } from "native-base";
import CommonDetailCard from "../../../detailCard";
import "./style.css";
import { COMMONFONTSIZE } from "../../../../utils/fonts";

export const WebBasicDetails = ({ data }) => {
  return (
    <>
      <Flex
        direction="row"
        flexWrap="wrap"
        justifyContent="space-between"
        width="100%"
      >
        {data.map((item, index) =>
          item.heading !== "Other Requirements" &&
          item.heading !== "About MICE" &&
          item.heading !== "About Event" ? (
            <Box key={index} width="19%" marginBottom="10">
              <CommonDetailCard heading={item.heading} text={item.name} />
            </Box>
          ) : (
            <Box
              key={index}
              width="97.2%"
              marginBottom={"10"}
              textAlign={"justify"}
            >
              <CommonDetailCard heading={item.heading} text={item.name} />
            </Box>
          )
        )}
      </Flex>
    </>
  );
};

export const MobileBasicDetails = ({ data }) => {
  return (
    <>
      <div className="grid-container-2">
        {data?.map((item) => {
          return item.heading === "Email ID 1" ||
            item.heading === "Event Location" ||
            item.heading === "MICE Location" ? (
            <div
              className="d-grid"
              style={{ marginBottom: "14px", wordBreak: "break-all" }}
            >
              <CommonDetailCard
                heading={item.heading}
                text={item.name}
                headingSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                textSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
              />
            </div>
          ) : (
            item.heading &&
              item.heading !== "Other Requirements" &&
              item.heading !== "About MICE" &&
              item.heading !== "About Event" && (
                <div className="d-grid" style={{ marginBottom: "14px" }}>
                  <CommonDetailCard
                    heading={item.heading}
                    text={item.name}
                    headingSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                    textSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                  />
                </div>
              )
          );
        })}
      </div>
      <div style={{ width: "100%" }}>
        {data?.map((item) => {
          return (
            item.heading &&
            (item.heading === "Other Requirements" ||
              item.heading === "About MICE" ||
              item.heading === "About Event") && (
              <div
                style={{
                  marginBottom: "14px",
                  width: "100%",
                  textAlign: "justify",
                }}
              >
                <CommonDetailCard
                  heading={item.heading}
                  text={item.name}
                  headingSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                  textSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                />
              </div>
            )
          );
        })}
      </div>
    </>
  );
};
